import BookingOptionsManagerService from "app/services/bookingOptionsManager/bookingOptionsManager.service";

const NS = 'NewUpsellCtrl';

export default function NewUpsellCtrl(
  $scope, $mdDialog, details, appConstants
) {
  "ngInject";

  const vm = this;
  vm.detailsParent = details;
  vm.paymentTypes = appConstants.Payment.PaymentTypes;
  vm.cancel = cancel;
  vm.save = save;

  init()

  function init() {
    // Load and map menuOptions
    BookingOptionsManagerService.getAll().then(options => {
      vm.menuOptionsUpsell = (vm.detailsParent.menuOptionsUpsell || []).reduce((acc, id) => {
        const matchedOpt = options.find(option => option._id === id);
        if (matchedOpt) {
          acc.push(matchedOpt);
        }
        return acc;
      }, []);
    });
  }

  function cancel() {
    $mdDialog.hide();
  }

  function save() {
    vm.detailsParent.menuOptionsUpsell = vm.menuOptionsUpsell.map(mo => mo._id);
    $mdDialog.hide();
  }
}
